import React from 'react'
import Hero from '../component/HomeHero_/Hero'
import Footer from '../component/Footer/Footer'
import { Helmet } from 'react-helmet'

function Home() {
  return (
    <div className=''>
      <Helmet>
          <title> 
          Upholstery Fabric Supplier Canada | Halton Surface Systems
          </title>
          <meta 
          name='description' 
          content="Halton Surface Systems is Canada's leading commercial upholstery fabric supplier. Shop outdoor, contract & healthcare upholstery fabric across Burlington, Oakville & Halton Region. Request samples today." 
          />
          <link rel="canonical" href="https://www.haltonsurfacesystems.com/" />

        </Helmet>
    <Hero/>

   <Footer/>
    </div>
  )
}

export default Home